/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBookingHandoffCapabilities
 */
export interface FlightBookingHandoffCapabilities {
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingHandoffCapabilities
   */
  internalCheckoutAvailable: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingHandoffCapabilities
   */
  externalBookingAvailable: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingHandoffCapabilities
   */
  reconfirmationRequired: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingHandoffCapabilities
   */
  requiresPaymentMethodPricing?: boolean;
}

/**
 * Check if a given object implements the FlightBookingHandoffCapabilities interface.
 */
export function instanceOfFlightBookingHandoffCapabilities(
  value: object
): value is FlightBookingHandoffCapabilities {
  if (
    !("internalCheckoutAvailable" in value) ||
    value["internalCheckoutAvailable"] === undefined
  )
    return false;
  if (
    !("externalBookingAvailable" in value) ||
    value["externalBookingAvailable"] === undefined
  )
    return false;
  if (
    !("reconfirmationRequired" in value) ||
    value["reconfirmationRequired"] === undefined
  )
    return false;
  return true;
}

export function FlightBookingHandoffCapabilitiesFromJSON(
  json: any
): FlightBookingHandoffCapabilities {
  return FlightBookingHandoffCapabilitiesFromJSONTyped(json, false);
}

export function FlightBookingHandoffCapabilitiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingHandoffCapabilities {
  if (json == null) {
    return json;
  }
  return {
    internalCheckoutAvailable: json["internal_checkout_available"],
    externalBookingAvailable: json["external_booking_available"],
    reconfirmationRequired: json["reconfirmation_required"],
    requiresPaymentMethodPricing:
      json["requires_payment_method_pricing"] == null
        ? undefined
        : json["requires_payment_method_pricing"],
  };
}

export function FlightBookingHandoffCapabilitiesToJSON(
  json: any
): FlightBookingHandoffCapabilities {
  return FlightBookingHandoffCapabilitiesToJSONTyped(json, false);
}

export function FlightBookingHandoffCapabilitiesToJSONTyped(
  value?: FlightBookingHandoffCapabilities | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_checkout_available: value["internalCheckoutAvailable"],
    external_booking_available: value["externalBookingAvailable"],
    reconfirmation_required: value["reconfirmationRequired"],
    requires_payment_method_pricing: value["requiresPaymentMethodPricing"],
  };
}
